import React from 'react'

import { Forms } from '../FormFields'

const FormComponent = ({ errorMessage, initialValues }) => (
  <Forms
    values={initialValues}
    errorMessage={errorMessage}
    label="Special Release Form"
  />
)

export default FormComponent
